import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[storeHost]',
})
export class StoreDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}